import { render, staticRenderFns } from "./InstrumentTree.vue?vue&type=template&id=52fc95d2"
import script from "./InstrumentTree.vue?vue&type=script&lang=ts"
export * from "./InstrumentTree.vue?vue&type=script&lang=ts"
import style0 from "./InstrumentTree.vue?vue&type=style&index=0&id=52fc95d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports